export const SEVERITY_ERROR = "error";
export const SEVERITY_WARNING = "warning";
export const SEVERITY_INFO = "info";
export const SEVERITY_SUCCESS = "success";